import React, { useEffect, useState } from "react";
import "../../Assets/Style/QuickShipments.scss";
import { Textbox, TextArea, SelectInput } from "../../components/FormInputs";
import Button from "../../components/Button";
import Header from "../../components/Header";
import HomeFooter from "../../components/Footer";
import axios from "axios";
import { toast } from "react-toastify";
import { generateTransactionID } from "../../Library/Utilities";
import { GetAllCountriesUrl, GetAllStatesUrl, GetAllCities } from "../../Library/URLs";

const user_id = localStorage.getItem("user_id") || "1";
const user_ses_id = localStorage.getItem("session_id") || "9531c2794d712f9980f05026a3285d69";
const company_id = localStorage.getItem("company_id") || "44";

const createQuickShipmentURL = `${process.env.REACT_APP_BASE_URL}create-quick-shipment`;

const QuickShipments = () => {
  const initialData = {
    sender_name: "",
    sender_email: "",
    sender_phone: "",
    sender_address: "",
    sender_address_2: "",
    sender_country: "",
    sender_state: "",
    sender_city: "",
    sender_postcode: "",
    receiver_name: "",
    receiver_email: "",
    receiver_phone: "",
    receiver_address: "",
    receiver_address_2: "",
    receiver_country: "",
    receiver_state: "",
    receiver_city: "",
    receiver_postcode: "",
    items_description: "",
    items_value: "",
    items_weight: "",
    insurance: "",
  };

  const [countriesPending, setCountriesPending] = useState(false);
  const [countries, setCountries] = useState([]);
  const [senderStatesPending, setSenderStatesPending] = useState(false);
  const [senderStates, setSenderStates] = useState([]);
  const [receiverStatesPending, setReceiverStatesPending] = useState(false);
  const [receiverStates, setReceiverStates] = useState([]);
  const [senderCitiesPending, setSenderCitiesPending] = useState(false);
  const [senderCities, setSenderCities] = useState([]);
  const [receiverCitiesPending, setReceiverCitiesPending] = useState(false);
  const [receiverCities, setReceiverCities] = useState([]);
  const [pending, setPending] = useState(false);

  const [formData, setFormData] = useState(initialData);

  useEffect(() => {
    fetchCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCountries = async () => {
    setCountriesPending(true);
    try {
      const res = await axios.post(GetAllCountriesUrl, {
        user_id,
        user_ses_id,
        company_id,
        transaction_id: generateTransactionID(15),
      });

      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Something went wrong.");
      }
      const countriesList = data.data.map((c) => ({
        label: c.country,
        value: c.country,
      }));
      setCountries(countriesList);
    } catch (err) {
      toast.dismiss();
      toast.error(err.message || "Failed to fetch countries.");
    } finally {
      setCountriesPending(false);
    }
  };

  const fetchStates = async (type = "Sender", country = "") => {
    if (type === "Sender") {
      setSenderStatesPending(true);
    } else {
      setReceiverStatesPending(true);
    }

    try {
      const res = await axios.post(GetAllStatesUrl, {
        user_id,
        user_ses_id,
        company_id,
        transaction_id: generateTransactionID(15),
        country,
      });

      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Something went wrong.");
      }
      let statesList = [];
      if (country === "Nigeria") {
        statesList = data.data.map((st) => {
          if (st.name === "Federal Capital Territory") {
            return {
              label: "Abuja",
              value: "Abuja",
            };
          } else {
            return {
              label: st.name?.replace(" State", ""),
              value: st.name?.replace(" State", ""),
            };
          }
        });
      } else {
        statesList = data.data.map((st) => {
          return {
            label: st.name,
            value: st.name,
          };
        });
      }

      if (type === "Sender") {
        setSenderStates(statesList);
      } else {
        setReceiverStates(statesList);
      }
    } catch (err) {
      toast.dismiss();
      toast.error(err.message || "Failed to fetch states.");
    } finally {
      setSenderStatesPending(false);
      setReceiverStatesPending(false);
    }
  };

  const fetchCities = async (type = "Sender", state = "") => {
    if (type === "Sender") {
      setSenderCitiesPending(true);
    } else {
      setReceiverCitiesPending(true);
    }

    try {
      const res = await axios.post(GetAllCities, {
        user_id,
        user_ses_id,
        company_id,
        transaction_id: generateTransactionID(15),
        country: type === "Sender" ? formData.sender_country : formData.receiver_country,
        state,
      });

      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Something went wrong.");
      }
      let statesList = data.data.map((ct) => {
        return {
          label: ct,
          value: ct,
        };
      });
      if (type === "Sender") {
        setSenderCities(statesList);
      } else {
        setReceiverCities(statesList);
      }
    } catch (err) {
      toast.dismiss();
      toast.error(err.message || "Failed to fetch cities.");
    } finally {
      setSenderCitiesPending(false);
      setReceiverCitiesPending(false);
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelect = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "sender_country") {
      fetchStates("Sender", value);
      setSenderCities([]);
    }

    if (name === "receiver_country") {
      fetchStates("Receiver", value);
      setReceiverCities([]);
    }

    if (name === "sender_state") {
      fetchCities("Sender", value);
    }

    if (name === "receiver_state") {
      fetchCities("Receiver", value);
    }
  };

  const submitRequest = async (e) => {
    e.preventDefault();

    if (formData.insurance === "") {
      toast.error("Choose insurance option!");
      return;
    }

    setPending(true);
    try {
      const res = await axios.post(createQuickShipmentURL, {
        user_id,
        user_ses_id,
        company_id,
        transaction_id: generateTransactionID(15),
        ...formData,
        insurance: formData.insurance,
      });

      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Something went wrong.");
      }
      toast.success(data.data);
      setFormData(initialData);
    } catch (err) {
      toast.dismiss();
      toast.error(err.message || "Failed to submit request.");
    } finally {
      setPending(false);
    }
  };

  return (
    <div>
      <Header />
      <div className="QuickShipmentsWrapper">
        <div className="QuickShipmentsHero">
          <h1 className="InfoHero">Quick Shipments</h1>
          <p className="InfoSub">
            Create a one-off shipment request in minutes. Provide pickup,
            delivery and package details and we will handle the rest.
          </p>
        </div>

        <div className="QuickShipmentsFormSection">
          <div className="FormContain">
            <h2 className="SectionHeader">Sender Details</h2>
            <div className="FormGrid">
              <Textbox
                value={formData.sender_name}
                name="sender_name"
                label="Sender Name"
                placeholder="Enter sender name"
                onChange={handleInput}
              />
              <Textbox
                value={formData.sender_email}
                name="sender_email"
                label="Sender Email (optional)"
                placeholder="Enter sender email"
                type="email"
                onChange={handleInput}
              />
              <Textbox
                value={formData.sender_phone}
                name="sender_phone"
                label="Sender Phone Number"
                placeholder="Enter sender phone number"
                onChange={handleInput}
              />
              <Textbox
                value={formData.sender_postcode}
                name="sender_postcode"
                label="Sender Postal Code (optional)"
                placeholder="Enter sender postal code"
                onChange={handleInput}
              />
            </div>

            <div className="FormGrid">
              <Textbox
                value={formData.sender_address}
                name="sender_address"
                label="Sender Address"
                placeholder="Enter sender address"
                onChange={handleInput}
              />
              <Textbox
                value={formData.sender_address_2}
                name="sender_address_2"
                label="Sender Address 2 (optional)"
                placeholder="Enter additional address information"
                onChange={handleInput}
              />
            </div>

            <div className="FormGrid">
              <div>
                {countriesPending && <p>Loading countries...</p>}
                <SelectInput
                  options={countries}
                  name="sender_country"
                  label="Sender Country"
                  value={formData.sender_country}
                  handleChange={handleSelect}
                />
              </div>
              <div>
                {senderStatesPending && <p>Loading states...</p>}
                <SelectInput
                  options={senderStates}
                  name="sender_state"
                  label="Sender State"
                  value={formData.sender_state}
                  handleChange={handleSelect}
                />
              </div>
              <div>
                {senderCitiesPending && <p>Loading cities...</p>}
                <SelectInput
                  options={senderCities}
                  name="sender_city"
                  label="Sender City"
                  value={formData.sender_city}
                  handleChange={handleSelect}
                />
              </div>
            </div>

            <h2 className="SectionHeader">Receiver Details</h2>
            <div className="FormGrid">
              <Textbox
                value={formData.receiver_name}
                name="receiver_name"
                label="Receiver Name"
                placeholder="Enter receiver name"
                onChange={handleInput}
              />
              <Textbox
                value={formData.receiver_email}
                name="receiver_email"
                label="Receiver Email (optional)"
                placeholder="Enter receiver email"
                type="email"
                onChange={handleInput}
              />
              <Textbox
                value={formData.receiver_phone}
                name="receiver_phone"
                label="Receiver Phone Number"
                placeholder="Enter receiver phone number"
                onChange={handleInput}
              />
              <Textbox
                value={formData.receiver_postcode}
                name="receiver_postcode"
                label="Receiver Postal Code (optional)"
                placeholder="Enter receiver postal code"
                onChange={handleInput}
              />
            </div>

            <div className="FormGrid">
              <Textbox
                value={formData.receiver_address}
                name="receiver_address"
                label="Receiver Address"
                placeholder="Enter receiver address"
                onChange={handleInput}
              />
              <Textbox
                value={formData.receiver_address_2}
                name="receiver_address_2"
                label="Receiver Address 2 (optional)"
                placeholder="Enter additional address information"
                onChange={handleInput}
              />
            </div>

            <div className="FormGrid">
              <div>
                {countriesPending && <p>Loading countries...</p>}
                <SelectInput
                  options={countries}
                  name="receiver_country"
                  label="Receiver Country"
                  value={formData.receiver_country}
                  handleChange={handleSelect}
                />
              </div>
              <div>
                {receiverStatesPending && <p>Loading states...</p>}
                <SelectInput
                  options={receiverStates}
                  name="receiver_state"
                  label="Receiver State"
                  value={formData.receiver_state}
                  handleChange={handleSelect}
                />
              </div>
              <div>
                {receiverCitiesPending && <p>Loading cities...</p>}
                <SelectInput
                  options={receiverCities}
                  name="receiver_city"
                  label="Receiver City"
                  value={formData.receiver_city}
                  handleChange={handleSelect}
                />
              </div>
            </div>

            <h2 className="SectionHeader">Shipment Details</h2>
            <div className="FormGrid">
              <Textbox
                value={formData.items_weight}
                name="items_weight"
                label="Items Weight (kg)"
                placeholder="Enter items weight"
                type="number"
                onChange={handleInput}
              />
              <Textbox
                value={formData.items_value}
                name="items_value"
                label="Items Value (NGN)"
                placeholder="Enter items value"
                type="number"
                onChange={handleInput}
              />
              <div>
                <SelectInput
                  options={[
                    { label: "Yes", value: "Yes" },
                    { label: "No", value: "No" },
                  ]}
                  name="insurance"
                  label="Insure Shipment (additional cost applied)"
                  value={formData.insurance}
                  handleChange={handleSelect}
                />
              </div>
            </div>

            <div className="TextAreaContain">
              <TextArea
                value={formData.items_description}
                name="items_description"
                label="Items Description"
                onChange={handleInput}
              />
            </div>

            <div className="BtnWrap">
              <Button
                text={
                  pending ? (
                    <span className="spinner-border spinner-grow-sm" />
                  ) : (
                    "Submit Request"
                  )
                }
                color="#1E3E8A"
                width="100%"
                onClick={submitRequest}
              />
            </div>
          </div>
        </div>
      </div>
      <HomeFooter />
    </div>
  );
};

export default QuickShipments;
